import React from 'react';
import { icons } from '@coach/ui';
import './styles.css';

const PagePreloader = () => <div className="pageLoader">{icons.logo}</div>;

export default PagePreloader;
